export const PULSE_VIEW = {
  MY: 'my',
  TEAM: 'team',
};

export const PULSE_CATEGORY = {
  NEEDS_ATTENTION: 'needs_attention',
  UPCOMING: 'upcoming',
  FYI: 'fyi',
};

// Ordered for top-to-bottom rendering in the feed.
export const PULSE_CATEGORY_ORDER = [
  PULSE_CATEGORY.NEEDS_ATTENTION,
  PULSE_CATEGORY.UPCOMING,
  PULSE_CATEGORY.FYI,
];

export const PULSE_ITEM_TYPE = {
  ACTION_READY: 'action-ready',
  TAKE_A_LOOK: 'take-a-look',
};

// Only the values POV branches on — pulse/README.md, Implementation notes.
// `chat_with_bizai` is the non-deterministic one — see the recommendation README, "Chat with BizAI".
export const PULSE_ACTION_TYPE = {
  ACKNOWLEDGE: 'acknowledge',
  REPLY: 'reply',
  CHAT_WITH_BIZAI: 'chat_with_bizai',
};

export const PULSE_STATUS = {
  ACTIVE: 'active',
  COMPLETED: 'completed',
  DISMISSED: 'dismissed',
  SUPPRESSED: 'suppressed',
};

// Transient in-place confirmation shown on a card after a secondary action,
// just before the item leaves the feed (see Figma "before disappearing").
export const PULSE_OUTCOME = {
  DONE: 'done',
  REMOVED: 'removed',
  SENT: 'sent',
};

// Phase of a confirmation. Every outcome runs both phases — see
// aiChat/entities/recommendation/README.md ("Scope") for the sequence and its rationale.
export const PULSE_OUTCOME_PHASE = {
  WORKING: 'working',
  SUCCEEDED: 'succeeded',
};

// How long "Working on it..." stays before the write goes out. Doubles as the undo window.
export const PULSE_OUTCOME_DISPLAY_MS = 1500;

// How long a resolved outcome holds its own tile before the card leaves the feed.
export const PULSE_SUCCESS_DISPLAY_MS = 1500;

// How long the Undo control takes to dissolve once its window closes.
// Keep in step with the `--dissolving` opacity transition on the cards.
export const PULSE_UNDO_DISSOLVE_MS = 200;

export const PULSE_PAGE_LIMIT = 25;

// Hard cap the aiplatform recommendations API enforces on per_page.
export const PULSE_MAX_PAGE_LIMIT = 100;

// How often the feed polls for background BizAI changes while the pane is open.
export const PULSE_POLL_INTERVAL_MS = 30000;

// How long the "BizAI updated" banner stays before it auto-dismisses.
export const PULSE_REFRESH_BANNER_MS = 4000;
